import { RewardsAccount } from "redmond";

// An account can pay toward the trip only if it allows redemption and has a
// positive balance. With none, "Do not apply my rewards" is the only real option.
export const hasUsableRewards = (rewardsAccounts: RewardsAccount[]): boolean =>
  rewardsAccounts.some(
    (account) =>
      (account.allowRewardsRedemption ?? true) &&
      account.rewardsBalance?.value > 0
  );
